import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compras-proveedor',
  templateUrl: './compras-proveedor.component.html',
  styleUrls: ['./compras-proveedor.component.css']
})
export class ComprasProveedorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
